import ExcelIcon from './images/export-excel.png';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import LocationComponent from '../../reportproblem/components/selectOptions/LocationComponent';
import ServiceType from './selectoptions/ServiceType';
import Department from './selectoptions/Department';
import DMA from '../../reportproblem/components/selectOptions/DMA';
import { formatInTimeZone } from 'date-fns-tz';
import { AppInfoContext } from '../../../../../../App';
import { useContext } from 'react';
import { getLabelByValue } from '../ProblemDetails';

export default function ExportToExcel({ height }) {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);
  function exportTextToExcel(rows, fileName = 'statistics.xlsx') {
    const workSheet = XLSX.utils.json_to_sheet(rows);

    workSheet['!cols'] = [
      { wch: 10 },
      { wch: 12 },
      { wch: 17 },
      { wch: 17 },
      { wch: 20 },
      { wch: 18 },
      { wch: 20 },
      { wch: 17 },
      { wch: 17 },
      { wch: 10 },
      { wch: 14 },
      { wch: 17 },
      { wch: 17 },
      { wch: 17 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, workSheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(blob, fileName);
  }

  const handleExport = () => {
    const rows = appInformation?.statistics?.data?.filteredProblems.map((r) => {
      return {
        Status:
          r.status === 0
            ? 'Neobrađen'
            : r.status === 1
            ? 'U obradi'
            : 'Zatvoren',

        'Broj r.n.': r?.workOrder?.serialNumber,
        'Datum prijave': formatInTimeZone(
          r.reportedAt,
          'Europe/Paris',
          'dd.MM.yyyy. HH:mm'
        ),
        Prijavio: `${r.user?.firstName ?? ''} ${r.user?.lastName ?? ''}`,
        Adresa: r.address,
        'DMA zona': getLabelByValue(r.dma, DMA) || '',
        Pozicija:
          getLabelByValue(
            r?.workOrder?.closedWorkOrder?.locationComponent ??
              r.locationComponent,
            LocationComponent
          ) || '',
        'Datum otvaranja r.n.': r?.workOrder?.createdAt
          ? formatInTimeZone(
              r?.workOrder?.createdAt,
              'Europe/Paris',
              'dd.MM.yyyy. HH:mm'
            )
          : '',
        'Datum zatvaranja r.n.': r.workOrder?.closedWorkOrder?.closedAt
          ? formatInTimeZone(
              r.workOrder.closedWorkOrder.closedAt,
              'Europe/Paris',
              'dd.MM.yyyy. HH:mm'
            )
          : '',
        'Tip usluge':
          r?.workOrder?.closedWorkOrder?.serviceType !== null &&
          r?.workOrder?.closedWorkOrder?.serviceType !== undefined
            ? getLabelByValue(
                r.workOrder.closedWorkOrder.serviceType,
                ServiceType
              )
            : '',
        'Služba izvršenja':
          r?.workOrder?.executionDepartment !== null &&
          r?.workOrder?.executionDepartment !== undefined
            ? getLabelByValue(r.workOrder.executionDepartment, Department)
            : '',
        'Datum popravke - od': r?.workOrder?.closedWorkOrder?.startDate
          ? formatInTimeZone(
              r.workOrder.closedWorkOrder.startDate,
              'Europe/Paris',
              'dd.MM.yyyy. HH:mm'
            )
          : '',
        'Datum popravke - do': r?.workOrder?.closedWorkOrder?.endDate
          ? formatInTimeZone(
              r.workOrder.closedWorkOrder.endDate,
              'Europe/Paris',
              'dd.MM.yyyy. HH:mm'
            )
          : '',
        Zatvorio: `${r?.workOrder?.closedWorkOrder?.user?.firstName ?? ''} ${
          r?.workOrder?.closedWorkOrder?.user?.lastName ?? ''
        }`,
        Cijena:
          r?.workOrder?.closedWorkOrder?.totalExpense !== null &&
          r?.workOrder?.closedWorkOrder?.totalExpense !== undefined
            ? `${Number(r.workOrder.closedWorkOrder.totalExpense).toFixed(
                2
              )} KM`
            : '',
      };
    });

    exportTextToExcel(
      rows,
      `(Statistika) ${formatInTimeZone(
        new Date(),
        'Europe/Paris',
        'dd.MM.yyyy.-HH:mm'
      )}.xlsx`
    );
  };

  return (
    <img
      height={height}
      src={ExcelIcon}
      alt=""
      className="stats-switch"
      onClick={handleExport}
    />
  );
}
